import React from 'react';
import './ListItem.styles.scss';
import Icon from '../Icon/Icon'; // Assuming Icon component is available
import { ListItemProps } from './ListItem.logic'; // Importing the prop interface

const ListItem: React.FC<ListItemProps> = ({
  icon,
  bullet,
  listtype = 'bullet',
  className = '',
  children,
}) => {
  const isDataRow = listtype === 'datarow';
  const wrapperClass = isDataRow ? 'bullet-wrapper' : 'icon-wrapper';

  return (
    <div className={`action-on-view action-fade-in list-item ${className}`}>
      <div className={wrapperClass}>
        {isDataRow ? <span>{bullet}</span> : <Icon icon={icon || bullet} />}
      </div>
      <div className="list-item-content">{children}</div>
    </div>
  );
};

export default ListItem;
